<template>
  <div class="col-sm-12 col-md">
    <InputWidget
      v-model="model"
      :error="errors"
      id="input-bank_account_account_number"
      type="text"
      :label="computedLabel"
      :placeholder="computedPlaceholder"
      @change="inputChange"
      @input="onInput"
      :rules="`${required || bankAccountFilledInSignup ? 'required' : ''}`"
    />
  </div>
</template>

<script>
import InputWidget from "../../../core/InputWidget";
import BaseInputMixin from "@/mixins/signupInputMixin";
import {mapGetters} from "vuex";

export default {
  name: "BankAccountNumber",
  components: {InputWidget},
  mixins: [BaseInputMixin('bank_account.account_number')],

  data() {
    return {
      name: 'account_number',
      defaultLabel: this.$t("Account Number")
    }
  },
  computed: {
    ...mapGetters(['bankAccountFilledInSignup'])
  }
}
</script>

<style scoped>

</style>
